import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HvSvg from 'src/components/HvSvg';
import uiDux from 'src/redux/ui';
import autobind from 'autobind-decorator';
import ExtendedSidebar from 'src/components/Sidebar/ExtendedSidebar';
import utils from 'src/utils';
import constants from 'src/constants';
import { utils as macheteUtils } from 'src/machete-redux';
import { get } from 'lodash';
import SegmentItem from './SegmentItem';
import MainMaterialItem from './MainMaterialItem';
import SurfaceAreaItem from './SurfaceAreaItem';
import OpeningItem from './OpeningItem';

import {
  Container,
  CloseButton,
  List,
  Title,
  ExtendedSidebarHeader,
} from './styled';

const { SEGMENTS_VISIBILITY_OPTS } = constants.machete;
const { MEASUREMENTS } = constants.measure;
const { isSegmentsCategory, isMainMaterialCategory } = utils.measure;

export const mapStateToProps = (state) => ({
  measurements: state.designPro.measure.measurements,
  activeCategoryName: state.designPro.measure.activeCategoryName,
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleCloseMeasureExtendedSidebarClick:
        uiDux.actions.handleCloseMeasureExtendedSidebarClick,
    },
    dispatch,
  );

export class MeasureExtendedSidebar extends PureComponent {
  static propTypes = {
    activeCategoryName: PropTypes.string,
    handleCloseMeasureExtendedSidebarClick: PropTypes.func.isRequired,
    measurements: PropTypes.object.isRequired,
  };

  componentWillUpdate() {
    if (this.listComponent) {
      this.listComponent.scrollTop = 0;
    }
  }

  @autobind
  outlineSelectedSegments(edges) {
    const { addOutlineToSegments, setDefaultVisibility } = macheteUtils;
    setDefaultVisibility(SEGMENTS_VISIBILITY_OPTS);
    addOutlineToSegments(edges);
  }

  renderSegmentItems() {
    const { measurements, activeCategoryName } = this.props;
    const { items } = measurements[activeCategoryName];

    return items.map((item) => (
      <SegmentItem
        count={item.count}
        edges={item.edges}
        feetInches={item.length.feetInches}
        key={item.key}
        name={item.displayName}
        outlineSegments={this.outlineSelectedSegments}
      />
    ));
  }

  renderMainMaterialItems() {
    const { measurements, activeCategoryName } = this.props;
    const mainMaterialItems = measurements[activeCategoryName].items;

    return mainMaterialItems.map((item) => (
      <MainMaterialItem
        key={item.key}
        letter={item.key}
        area={get(item, 'area.feet', 0)}
        uuid={item.uuid}
      />
    ));
  }

  renderSurfaceAreaItems() {
    const surfaceAreas = this.props.measurements[MEASUREMENTS.surfaceAreas];

    return surfaceAreas.items.map((item) => (
      <SurfaceAreaItem
        key={item.displayName}
        thumbnailUrl={item.thumbnailUrls[0]}
        count={item.count}
        name={item.displayName}
        area={get(item, 'area.feet', 0)}
        uuids={item.uuids}
      />
    ));
  }

  renderOpenings() {
    const openings = this.props.measurements[MEASUREMENTS.openings];

    return openings.items.map((item) => (
      <OpeningItem
        key={item.name}
        name={item.name}
        width={get(item, 'width.inches', 0)}
        height={get(item, 'height.inches', 0)}
        uuid={item.uuid}
      />
    ));
  }

  render() {
    const {
      handleCloseMeasureExtendedSidebarClick,
      activeCategoryName,
    } = this.props;

    return (
      <ExtendedSidebar
        shouldIgnoreOutsideClicks
        render={() => (
          <Container>
            <ExtendedSidebarHeader
              onClick={handleCloseMeasureExtendedSidebarClick}
            >
              <CloseButton icon="close">
                <HvSvg
                  src={require('src/assets/images/right-arrow.svg')}
                  disabled={false}
                />
              </CloseButton>
              <Title>{activeCategoryName}</Title>
            </ExtendedSidebarHeader>
            <List
              innerRef={(c) => {
                this.listComponent = c;
              }}
            >
              {isSegmentsCategory(activeCategoryName) &&
                this.renderSegmentItems()}
              {isMainMaterialCategory(activeCategoryName) &&
                this.renderMainMaterialItems()}
              {activeCategoryName === MEASUREMENTS.surfaceAreas &&
                this.renderSurfaceAreaItems()}
              {activeCategoryName === MEASUREMENTS.openings &&
                this.renderOpenings()}
            </List>
          </Container>
        )}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MeasureExtendedSidebar);
